import React, { useState, useEffect, useRef } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import { useNavigate , Link} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Table, BarChart } from "react-bootstrap-icons"
import "./table.css";
import Select from "react-select";
import { MdRefresh } from "react-icons/md";
import { TabView, TabPanel } from "primereact/tabview";
import { MdNotificationsActive } from "react-icons/md";
import { BlobServiceClient } from "@azure/storage-blob";
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
const AUTH_KEYS = [
  "JWT", "userName", "organization", "loginType", "companyid", "companyName", "features",
  "legal1", "business1", "country1", "site1", "year1",
  "scope2legal", "scope2business", "scope2country", "scope2site", "scope2supplier", "scope2year",
  "businessTravelLegal", "businessTravelBusiness", "businessTravelCountry", "businessTravelSite", "businessTravelYear",
  "transportlegal", "transportbusiness", "transportcountry", "transportsite", "transportyear",
  "sbusiness", "scountry", "sjob", "slegal", "ssite", "syear",
  "allconfig", "report", "reportStatusData", "report_name",
  "savedReports", "savedStatus", "savedSurveys",
  "brsr_report_id", "brsr_sectionA_data", "brsrSectionCPopup",
  "step1", "step2", "step2Draft", "step3", "step4",
  "answers", "answers1", "answers2", "tableAnswers",
  "selectedOptions", "csrd", "type", "mdrp", "e1", "s1",
  "scfFormInProgress", "scfStep1", "scfStep2",
  "editFieldMapping", "popup1", "popup2", "popup3",
  "bloburl", "logo", "hash", "linkToken", "linkUrl",
  "weblink", "statusDashboardUrl", "statusReportFile",
  "oldp", "redirectAfterLogin",
];

const ESGBenchmarking = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const [isOpen, setIsOpen] = useState(false);
  const username = localStorage.getItem("userName");
  const handleLogout = () => {
    AUTH_KEYS.forEach(k => localStorage.removeItem(k));
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    companyName: [],
    sector: [],
    country: [],
    competitors: [],
    year: [],
  });
  const [viewMode, setViewMode] = useState("table")
  const [data, setData] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [competitorsOptions, setCompetitorsOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [tab3total, setTab3Total] = useState();
  const [tab2total, setTab2Total] = useState();
  const [searchText, setSearchText] = useState("");
  const [fontSize, setFontSize] = useState(window.innerWidth >= 1400 ? "15px" : "13px");

  const resetSelections = () => {
    setFormData({
      companyName: null, // ✅ Change from [] to null for clearing the dropdown
      sector: [],
      country: [],
      competitors: [],
      year: "",
    });
    setSearchText(""); 
    setFilteredEmissionsData([]);
    setFilteredTargetsData([]);
    setFilteredReportingData([]);
  };

  const [filteredEmissionsData, setFilteredEmissionsData] = useState([]);
  const [filteredTargetsData, setFilteredTargetsData] = useState([]);
  const [filteredReportingData, setFilteredReportingData] = useState([]);

  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    // Trigger the file input click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    // Access the uploaded files
    const files = event.target.files;
    if (files.length > 0) {
      console.log("Files selected:", files);
      // Add logic to handle file upload
    }
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    companyName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    sector: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country: { value: null, matchMode: FilterMatchMode.CONTAINS },
    year: { value: null, matchMode: FilterMatchMode.CONTAINS },
    revenue: { value: null, matchMode: FilterMatchMode.CONTAINS },
    employees: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope1Emissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope2Emissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope3Emissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    economicEmissionIntensity: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    emissionIntensityPerEmployee: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [emissionsData, setEmissionsData] = useState([]);
  const [targetsData, setTargetsData] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [companyFilter, setCompanyFilter] = useState("");
  const [sectorFilter, setSectorFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [competitorFilter, setCompetitorFilter] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const [isDataRendered, setIsDataRendered] = useState(false);

  // Initial load effect
  useEffect(() => {
    // Set initial loading state
    setLoading(true);
    // Load initial data
    onPageLoadFilter().then(() => {
      setLoading(false);
    }).catch(error => {
      console.error("Error in initial load:", error);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (emissionsData.length > 0) {
      // Reset the rendered state when new data arrives
      setIsDataRendered(false);
      
      // Use requestAnimationFrame to ensure DOM has updated
      requestAnimationFrame(() => {
        // Add a small delay to ensure table is rendered
        setTimeout(() => {
          setIsDataRendered(true);
        }, 500); // Reduced delay from 1000ms to 500ms
      });
    } else {
      // If no data, set rendered to true immediately
      setIsDataRendered(true);
    }
  }, [emissionsData]);

  useEffect(() => {
    console.log('Form Data Changed:', formData);
    // Set loading to true when form data changes
    setLoading(true);
    setIsDataRendered(false);
    
    // Use Promise.all to ensure all async operations complete
    Promise.all([
      fetchDatas(),
      fetchGraphData(),
      onPageLoadFilter()
    ]).then(() => {
      // All operations completed successfully
      console.log('All operations completed');
      // Always set loading to false after operations complete, regardless of data
      setLoading(false);
    }).catch(error => {
      console.error("Error in form data change:", error);
      setLoading(false);
    });
  }, [formData]);

  // Determine if filters are applied
  const isFilterApplied = Object.values(formData).some((value) => value);

  const ensureArray = (value) => {
    if (Array.isArray(value)) {
      return value;
    }
    if (value !== undefined && value !== null && value !== "") {
      return [value];
    }
    return [];
  };

  const fetchDatas = async () => {
    // Don't set loading here as it's already set in the useEffect
    setIsDataRendered(false);
    
    // Add a timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      setLoading(false);
      setIsDataRendered(true);
    }, 30000); // 30 seconds timeout
    
    try {
      const requestBody = {
        companyNames: formData.companyName?.length > 0 ? [formData.companyName] : [],
        sectors: formData.sector?.length > 0 ? formData.sector : [],
        countries: formData.country?.length > 0 ? formData.country : [],
        competitors: formData.competitors?.length > 0 ? formData.competitors : [],
        years: ensureArray(formData.year)
      };

      

      const apiRequests = [
        {
          url: `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking`,
          body: requestBody,
          setData: setEmissionsData,
        },
      ];

      const responses = await Promise.all(
        apiRequests.map(async ({ url, body }) => {
          console.log('Making request to:', url);
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              username,
            },
            body: JSON.stringify(body),
          });
          console.log('Response status:', response.status);
          return response;
        })
      );

      await Promise.all(
        responses.map(async (res, index) => {
          const { setData } = apiRequests[index];
          if (res.status === 200) {
            const responseJson = await res.json();
            console.log('API Response:', responseJson);
            if (Array.isArray(responseJson)) {
              setData(responseJson);
            } else {
              console.log('Response is not an array:', responseJson);
              setData([]);
            }
          } else {
            const errorData = await res.json();
            console.error(`Error with API: ${apiRequests[index].url}`, errorData);
            setData([]);
          }
        })
      );
      
      // Clear timeout on successful completion
      clearTimeout(timeoutId);
    } catch (error) {
      console.error("Error in fetchDatas:", error);
      setEmissionsData([]);
      // Clear timeout on error
      clearTimeout(timeoutId);
    }
    // Note: Don't set loading to false here as it's handled by the Promise.all in useEffect
  };

  const onDropdownChange = (e, rowData, field) => {
    const updatedData = targetsData.map((row) => {
      if (row === rowData) {
        return { ...row, [field]: e.value };
      }
      return row;
    });
    setTargetsData(updatedData);
  };

  const onInputChange = (e, rowData, field) => {
    const updatedData = targetsData.map((row) => {
      if (row === rowData) {
        return { ...row, [field]: e.target.value };
      }
      return row;
    });
    setTargetsData(updatedData);
  };

  const netZeroTargetTemplate = (rowData) => {
    return <Dropdown value={rowData.netZeroTarget} options={yesNoOptions} onChange={(e) => onDropdownChange(e, rowData, "netZeroTarget")} placeholder="Yes/No" />;
  };

  const nearTermTargetTemplate = (rowData) => {
    return <InputNumber value={rowData.nearTermTarget} onValueChange={(e) => onInputChange(e, rowData, "nearTermTarget")} placeholder="Enter Value" />;
  };

  const targetStatementTemplate = (rowData) => {
    return <InputText value={rowData.targetStatement} onChange={(e) => onInputChange(e, rowData, "targetStatement")} placeholder="Enter statement" />;
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: value, matchMode: FilterMatchMode.CONTAINS },
    }));
    setGlobalFilterValue(value);
  };


  const onPageLoadFilter = async () => {
    const e = activeIndex;
    // Reset filters for the newly selected tab
    const requestBody1 = {
      companyNames: formData.companyName?.length > 0 ? [formData.companyName] : [],
      sectors: formData.sector?.length > 0 ? formData.sector : [],
      countries: formData.country?.length > 0 ? formData.country : [],
      competitors: formData.competitors?.length > 0 ? formData.competitors : [],
      years: ensureArray(formData.year),
    };
    console.log(formData);

    try {
      let url = "";
      let requestBody = {};
      // Determine API and request body based on the active tab
      url = `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking-filter`;
      requestBody = requestBody1;
      // Fetch data for the selected tab
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username,
        },
        body: JSON.stringify(requestBody),
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        // Update the data state based on the active tab
        console.log("Emission");
        setCompanyOptions(responseJson.companyNames.map((name) => ({ label: name, value: name })));
        setSectorOptions(responseJson.sectors.map((name) => ({ label: name, value: name })));
        setCountryOptions(responseJson.countries.map((name) => ({ label: name, value: name })));
        const competitorsOptions = Object.entries(responseJson.competitors).map(([name, isSelected]) => ({
          label: name,
          value: name,
          selected: isSelected, // true if the value is true, false otherwise
        }));
        setCompetitorsOptions(competitorsOptions);
        setYearOptions(responseJson.years.map((name) => ({ label: name, value: name })));
        
      } else {
        console.error(`Error fetching data for tab index ${e.index}`);
      }
    } catch (error) {
      console.error("Error in onPageLoadFilter:", error);
      throw error; // Re-throw the error so it can be caught by the calling function
    }
    // Note: Don't set loading to false here as it's handled by the main fetchDatas function
  };

  //Fetch API for Graph Data
  const fetchGraphData = async () => {
    const requestBody = {
      companyNames: formData.companyName?.length > 0 ? [formData.companyName] : [],
      sectors: formData.sector?.length > 0 ? formData.sector : [],
      countries: formData.country?.length > 0 ? formData.country : [],
      competitors: formData.competitors?.length > 0 ? formData.competitors : [],
      years: ensureArray(formData.year),
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}emission-benchmarking-graph`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      setGraphData(result);
      console.log(result);
    } catch (err) {
      console.error("Error fetching graph data:", err);
    }
    // Note: Don't set loading to false here as it's handled by the main fetchDatas function
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <img src="assets/img/search.png" className="search-i" alt="search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  // Numeric-only filter: allow digits and optional decimal (e.g. for revenue, intensity)
  const renderNumericFilter = (options, integersOnly = false) => {
    const pattern = integersOnly ? /^\d*$/ : /^\d*\.?\d*$/;
    return (
      <input
        type="text"
        inputMode="numeric"
        className="p-inputtext p-component"
        value={options.value ?? ""}
        onChange={(e) => {
          const val = e.target.value;
          if (pattern.test(val) || val === "") {
            options.filterApplyCallback(val === "" ? null : val);
          }
        }}
        onKeyDown={(e) => {
          const key = e.key;
          if (key === "Backspace" || key === "Delete" || key === "Tab" || key === "ArrowLeft" || key === "ArrowRight") return;
          if (integersOnly && /^\d$/.test(key)) return;
          if (!integersOnly && (/^\d$/.test(key) || (key === "." && !e.target.value.includes(".")))) return;
          e.preventDefault();
        }}
        placeholder="Filter"
        style={{ width: "100%" }}
      />
    );
  };

  // Text filter (no numbers): blocks 0-9 for sector/country filters
  const renderNoNumberTextFilter = (options) => {
    return (
      <input
        type="text"
        className="p-inputtext p-component"
        value={options.value ?? ""}
        onChange={(e) => {
          const val = e.target.value ?? "";
          const sanitized = String(val).replace(/\d+/g, "");
          options.filterApplyCallback(sanitized === "" ? null : sanitized);
        }}
        onKeyDown={(e) => {
          const key = e.key;
          if (
            key === "Backspace" ||
            key === "Delete" ||
            key === "Tab" ||
            key === "ArrowLeft" ||
            key === "ArrowRight" ||
            key === "Home" ||
            key === "End" ||
            e.ctrlKey ||
            e.metaKey
          ) {
            return;
          }
          if (/^\d$/.test(key)) e.preventDefault();
        }}
        onPaste={(e) => {
          const pasted = e.clipboardData?.getData("text") ?? "";
          if (/\d/.test(pasted)) e.preventDefault();
        }}
        placeholder="Filter"
        style={{ width: "100%" }}
      />
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#00366D26",
      background: "#F5F5F5",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#407775", // Change border color on hover
      },
      fontSize: fontSize, // Set font size for control (including selected option)
      color: "#707070!important", // Set default text color for the control
      paddingLeft:
        state.selectProps.name === "companyName" && (!formData.companyName || formData.companyName.length === 0)
          ? "30px"
          : state.selectProps.name === "sector" && (!formData.sector || formData.sector.length === 0)
          ? "30px"
          : state.selectProps.name === "region" && (!formData.region || formData.region.length === 0)
          ? "30px"
          : state.selectProps.name === "country" && (!formData.country || formData.country.length === 0)
          ? "30px"
          : state.selectProps.name === "competitors" && (!formData.competitors || formData.competitors.length === 0)
          ? "30px"
          : state.selectProps.name === "year" && (!formData.year || formData.year.length === 0)
          ? "30px"
          : "0px", // Default padding if the field is filled
      position: "relative",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#707070",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        color: "#707070", // Change border color on hover
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the separator
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu is above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused || state.isSelected ? "#eef1f5" : "white", // Hover and selected background color
      color: state.isSelected ? "#407775" : "#707070", // Change text color for selected options
      fontSize: fontSize, // Use fontSize state variable for options
      "&:active": {
        backgroundColor: "#eef1f5", // Change color on active (click)
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: fontSize, // Set font size for the placeholder
      color: "#707070", // Set placeholder color
    }),
  };

  useEffect(() => {
      if (emissionsData.length > 0) {
        if(formData.competitors.length === 0){
          const filteredEmissions = emissionsData.filter((item) => {
            const matchesCompany = !formData.companyName || formData.companyName.length === 0 || formData.companyName.includes(item.companyName);
            const matchesSector = formData.sector.length === 0 || formData.sector.includes(item.sector);
            const matchesCountry = formData.country.length === 0 || formData.country.includes(item.country);
            const matchesYear = !formData.year || formData.year === String(item.year);
      
            return matchesCompany && matchesSector && matchesCountry && matchesYear;
          });
          console.log("If Condtition");
          setFilteredEmissionsData(filteredEmissions);
        }
        else{
          console.log("Else Condtition");
          
        }
      } else {
        // console.log("No emissions data found.");
        setFilteredEmissionsData([]); // Prevent errors
        // Don't set loading to false here as it should be controlled by the main useEffect
      }
  }, [emissionsData, formData]);

    // Sample data for charts
    // Simple component for displaying charts
  const EmissionsCharts = ({ companyName = "Gartner" }) => {
  // Donut chart for emissions by scope
  const donutChartOptions = {
    chart: {
      type: "pie",
      height: 300,
      backgroundColor: "transparent",
    },
    title: {
      text: `GHG emissions (tCO2e) ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y:,.0f} tCO2e</b>",
    },
    plotOptions: {
      pie: {
        innerSize: "60%",
        dataLabels: {
          enabled: true,
          distance: 30,
          connectorWidth: 1,
          connectorColor: "#666",
          format: "{point.name}: {point.y:,.0f} tCO2e",
          style: {
            fontWeight: "normal",
            fontSize: "11px",
          },
          connectorPadding: 5,
        },
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Emissions",
        data: [
          { name: "Scope 1", y: graphData?.scope1GHGEmission || 0, color: "#6F9896" },
          { name: "Scope 2", y: graphData?.scope2GHGEmission || 0, color: "#FAB430" },
          { name: "Scope 3", y: graphData?.scope3GHGEmission || 0, color: "#B4A34A" },
        ],
      },
    ],
    credits: { enabled: false },
  }

  // Bar chart for sector comparison
  const sectorComparisonOptions = {
    chart: {
      type: "column",
      height: 330,
      backgroundColor: "transparent",
    },
    title: {
      text: `GHG emissions comparison with sector average for ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: ["Scope 1", "Scope 2", "Scope 3"],
      crosshair: true,
    },
    yAxis: {
      type: 'logarithmic',
      min: 1000, // Set minimum to avoid log(0) issues
      title: {
        text: "Emissions (tCO2e) - Log Scale",
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString()
        },
      },
      minorTickInterval: 0.1,
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<table>",
      pointFormat:
        '<tr><td style="color: {series.color};">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y:,.0f} tCO2e</b></td></tr>',
      footerFormat: "</table>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        pointWidth: 25,
        dataLabels: {
          enabled: true,
          format: '{y:,.0f}',
          style: {
            fontSize: '11px',
            fontWeight: 'normal'
          }
        }
      },
    },
    series: [
      {
        name: "Company specific GHG emissions (tCO2e)",
        color: "#B4C9C8",
        data: [graphData?.scope1CompanySpecificGHGEmission || 0, graphData?.scope2CompanySpecificGHGEmission || 0, graphData?.scope3CompanySpecificGHGEmission || 0],
      },
      {
        name: "Sector average (tCO2e)",
        color: "#FAB430",
        data: [graphData?.scope1SectorGHGEmission || 0, graphData?.scope2SectorGHGEmission || 0, graphData?.scope3SectorGHGEmission || 0],
      },
    ],
    credits: { enabled: false },
  }

  const scope1Peers = graphData.scope1GHGEmissionWithIndustryPeers || {};
  const scope2Peers = graphData.scope2GHGEmissionWithIndustryPeers || {};
  const scope3Peers = graphData.scope3GHGEmissionWithIndustryPeers || {};

  const uniqueCompanies = [
    ...new Set([
      ...Object.keys(scope1Peers),
      ...Object.keys(scope2Peers),
      ...Object.keys(scope3Peers),
    ]),
  ];
  const colorPalette = ["#6F9896", "#FAB430", "#B4C9C8", "#A167A5", "#70A0AF"];
  const dynamicSeries = uniqueCompanies.map((company,index) => ({
    name: company,
    data: [
      scope1Peers[company] || 0,
      scope2Peers[company] || 0,
      scope3Peers[company] || 0,
    ],
    color: colorPalette[index % colorPalette.length], // Cycle through colors
  }));
  // Bar chart for peer comparison
  const peerComparisonOptions = {
    chart: {
      type: "column",
      height: 330,
      backgroundColor: "transparent",
    },
    title: {
      text: `GHG emissions comparison with industry peers of ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: ["Scope 1", "Scope 2", "Scope 3"],
      crosshair: true,
    },
    yAxis: {
      type: 'logarithmic',
      min: 1000, // Set minimum to avoid log(0) issues
      title: {
        text: "Emissions (tCO2e) - Log Scale",
      },
      labels: {
        formatter: function () {
          return this.value.toLocaleString()
        },
      },
      minorTickInterval: 0.1,
    },
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<table>",
      pointFormat:
        '<tr><td style="color: {series.color};">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y:,.0f} tCO2e</b></td></tr>',
      footerFormat: "</table>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        pointWidth: 20, // Increased bar width for better visibility
        dataLabels: {
          enabled: true,
          format: '{y:,.0f}',
          style: {
            fontSize: '10px',
            fontWeight: 'normal'
          }
        }
      },
    },
    series: dynamicSeries,
    credits: { enabled: false },
  }


  // Bar chart for intensity comparison
  const companies = Object.keys(graphData.economicEmissionIntensity || {});
  const economicIntensitySeries = {
    name: "Economic emission intensity (tCO2e/currency)",
    color: "#B4A34A",
    data: companies.map((company) => graphData.economicEmissionIntensity[company] ?? 0),
  };
  
  const employeeIntensitySeries = {
    name: "Emission intensity per employee (tCO2e/employee)",
    color: "#6F9896",
    data: companies.map((company) => graphData.emissionIntensityPerEmployee[company] ?? 0),
  };

  // Calculate dynamic maximum value based on actual data
  const allIntensityValues = [
    ...economicIntensitySeries.data,
    ...employeeIntensitySeries.data
  ].filter(value => value > 0); // Filter out zero values

  const maxValue = allIntensityValues.length > 0 ? Math.max(...allIntensityValues) : 10;
  
  // Calculate dynamic tick interval based on maximum value
  const getTickInterval = (max) => {
    if (max <= 10) return 2;
    if (max <= 50) return 10;
    if (max <= 100) return 20;
    if (max <= 500) return 50;
    if (max <= 1000) return 100;
    return Math.ceil(max / 10);
  };

  const tickInterval = getTickInterval(maxValue);
  const dynamicMax = Math.ceil(maxValue / tickInterval) * tickInterval + tickInterval; // Round up to next tick
  
  const intensityOptions = {
    chart: {
      type: "bar",
      height: 330,
      backgroundColor: "transparent",
    },
    title: {
      text: `Emission intensity comparison with industry peers of ${companyName}`,
      style: {
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: companies,
      title: { text: null },
    },
    yAxis: [
      {
        min: 0,
        max: dynamicMax, // Dynamic max value based on actual data
        tickInterval: tickInterval, // Dynamic tick interval
        title: {
          text: "",
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
      },
      {
        min: 0,
        title: {
          text: "",
          align: "high",
        },
      
      },
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      headerFormat: "<table>",
      pointFormat:
        '<tr><td style="color: {series.color};">{series.name}: </td>' +
        '<td style="text-align: right"><b>{point.y:.2f}</b></td></tr>',
      footerFormat: "</table>",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "{y:.2f}",
        },
      },
    },
    series: [economicIntensitySeries, employeeIntensitySeries],
    credits: { enabled: false },
  }

  const totalEmissions = 130000 // 5000 + 25000 + 100000

  return (
    <div className="row">
      <div className="col-md-6 mb-4">
        <div className="card" style={{ height: '350px' }}>
          <div className="card-body d-flex flex-column" style={{ height: '100%' }}>
            <div style={{ flex: '1', minHeight: '0' }}>
              <HighchartsReact highcharts={Highcharts} options={donutChartOptions} />
            </div>
            <div className="d-flex justify-content-center mt-3">
              <div className="d-flex align-items-center me-3">
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#6F9896",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></div>
                <span className="small">Scope 1</span>
              </div>
              <div className="d-flex align-items-center me-3">
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#FAB430",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></div>
                <span className="small">Scope 2</span>
              </div>
              <div className="d-flex align-items-center me-3">
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    backgroundColor: "#B4A34A",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></div>
                <span className="small">Scope 3</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card" style={{ height: '350px' }}>
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={sectorComparisonOptions} />
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card" style={{ height: '350px' }}>
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={peerComparisonOptions} />
          </div>
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card" style={{ height: '350px' }}>
          <div className="card-body">
            <HighchartsReact highcharts={Highcharts} options={intensityOptions} />
          </div>
        </div>
      </div>
    </div>
  )
    }

  // Remove this conflicting useEffect as loading is now managed properly in the main useEffect

  return (
    <div id="wrapper">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div id="">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid  mx-4 my-2">
              <div className="d-flex align-items-center">
                <a className="navbar-brand d-flex align-items-center p-0" href="#home">
                  <img src="assets/img/logo.png" alt="Company Logo" height="30" />
                </a>
                <div
                  className="mx-2"
                  style={{
                    borderLeft: "1px solid #fff",
                    height: "30px",
                    paddingLeft: "20px",
                    opacity: "0.5",
                  }}
                ></div>
                <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                  Organization Name
                </span>
              </div>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0 d-flex align-items-center">
                  <li className="nav-item">
                    <a className="nav-link  text-white" href="#notifications">
                      <MdNotificationsActive className="icon" style={{ width: "1.5rem", height: "1.5rem" }} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <span className="text-white nav-link" style={{ opacity: "0.7", fontSize: "14px", cursor: "default" }}>
                      {username}
                    </span>
                  </li>
                  <li className="nav-item dropdown" style={{ position: "relative" }}>
                    <a className="nav-link text-white" href="#" onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen); }}>
                      <img className="icon mr-2" src="assets/img/User.png" alt="User" />
                    </a>
                    {isOpen && (
                      <ul className="dropdown-menu show" style={{ position: "absolute", right: 0, top: "100%", zIndex: 9999, minWidth: "160px", overflow: "hidden", borderRadius: "4px" }}>
                        <li><button onMouseEnter={e => { e.currentTarget.style.background = "#407775"; e.currentTarget.style.color = "#fff"; }} onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "#212529"; }} style={{ color: "#212529", background: "none", border: "none", width: "100%", textAlign: "left", padding: "6px 16px", cursor: "pointer" }} onClick={handleLogout}>Logout</button></li>
                      </ul>
                    )}
                  </li>
                  <li className="nav-item">
                    <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                      XYZ ltd
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>

        <div className="container survey-form scf p-4 p-lg-5">
          <div className="row">
            <div className="col">
              <Link to="/esg-benchmarking" style={{ color: "#407775", fontSize: "14px", textDecoration: "none" }}>
                Home
              </Link>
            </div>
          </div>
          <div className="row my-4">
            <div className="col">
              <div className="form-header d-flex justify-content-between">
                <h1 className="title" style={{ color: "#494949" }}>
             Emission Benchmarking
                </h1>
                <Button className="refresh-cta" onClick={resetSelections} variant="text" startIcon={<MdRefresh />}>
                  Reset Filters
                </Button>
              </div>
            </div>
          </div>
          <div className="form-part">
            <form>
              <div className="row gx-2 gy-3">
                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Company Name</label>
                  <div className="input-group position-relative">
                    {(!formData.companyName || formData.companyName.length === 0) && (
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="companyName"
                      value={companyOptions.find((option) => option.value === formData.companyName) || null} // ✅ Ensure null resets it
                      options={companyOptions}
                      onChange={(e) => setFormData({ ...formData, companyName: e ? e.value : null })} // ✅ Ensure null if cleared
                      placeholder="Search"
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                    />

                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Sector</label>
                  <div className="input-group position-relative">
                    {(!formData.sector || formData.sector.length === 0) && ( // Conditionally render the search icon
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="sector"
                      value={sectorOptions.filter((option) => formData.sector?.includes(option.value))}
                      options={sectorOptions}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            sector: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">Country</label>
                  <div className="input-group position-relative">
                    {(!formData.country || formData.country.length === 0) && ( // Conditionally render the search icon
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="country"
                      value={countryOptions.filter((option) => formData.country?.includes(option.value))}
                      options={countryOptions}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            country: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>

                <div className="col-xl-2 col-lg-4 col-md-6">
                  <label className="formlable">
                    Select Competitors <span style={{ fontSize: "10px" }}>(Upto 5)</span>
                  </label>
                  <div className="input-group position-relative">
                    {(!formData.competitors || formData.competitors.length === 0) && (
                      <span className="search-icon">
                        <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                      </span>
                    )}
                    <Select
                      name="competitors"
                      value={competitorsOptions.filter((option) => formData.competitors?.includes(option.value))}
                      options={competitorsOptions}
                      onChange={(selectedOptions) => {
                        console.log("Selected Competitors:", selectedOptions);
                        console.log("Form Data:", formData);
                        if (selectedOptions.length <= 5) {
                          setFormData({
                            ...formData,
                            competitors: selectedOptions.map((opt) => opt.value),
                          });
                        }
                      }}
                      placeholder="Search"
                      isMulti
                      isSearchable
                      styles={customStyles}
                      className="custom-select-with-icon wd-100"
                      maxMenuHeight={200} // Limit dropdown height if needed
                    />
                  </div>
                </div>
                {activeIndex !== 2 && (
                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable">Year</label>
                    <div className="input-group position-relative">
                      {(!formData.year || formData.year.length === 0) && (
                        <span className="search-icon">
                          <img src="assets/img/search.png" alt="Search Icon" className="search-i" />
                        </span>
                      )}
                      <Select
                        name="year"
                        value={formData.year ? yearOptions.find((option) => option.value === formData.year) : null}
                        options={yearOptions}
                        onChange={(e) => setFormData({ ...formData, year: e.value })}
                        placeholder="Search"
                        isSearchable
                        styles={customStyles}
                        className="custom-select-with-icon wd-100"
                      />
                    </div>
                  </div>
                )}
              </div>
           {/* View Toggle */}
        <div className="d-flex mt-4 mb-4">
          <div className="btn-group">
            <button
              type="button"
              className={`btn ${viewMode === "table" ? "btn-toggle" : "btn-outline-toggle"}`}
              onClick={() => setViewMode("table")}
            >
              <Table className="me-1" /> Table
            </button>
            <button
              type="button"
              className={`btn ${viewMode === "graph" ? "btn-toggle" : "btn-outline-toggle"}`}
              onClick={() => setViewMode("graph")}
            >
              <BarChart className="me-1" /> Graph
            </button>
          </div>
        </div>

        {/* Content based on view mode */}
        {viewMode === "table" ? (
          <>

              <div className="row tabs mt-5">
              
                    <div className="data-responsive">
                      <DataTable
                        value={emissionsData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 25, 50]}
                        scrollable
                        scrollDirection="horizontal"
                        tableStyle={{ minWidth: "120rem" }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        filters={filters}
                        filterDisplay="row"
                        globalFilterFields={["companyName", "sector", "country", "year", "revenue", "employees", "scope1Emissions", "scope2Emissions", "scope3Emissions", "totalEmissions", "economicEmissionIntensity", "emissionIntensityPerEmployee"]}
                        header={header}
                        emptyMessage="No data found."
                      >
                        <Column field="companyName" header="Company" sortable filter filterPlaceholder="Filter" style={{ width: "10%" }} />
                        <Column
                          field="sector"
                          header="Sector"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "10%" }}
                          filterElement={(options) => renderNoNumberTextFilter(options)}
                        />
                        <Column
                          field="country"
                          header="Country"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "10%" }}
                          filterElement={(options) => renderNoNumberTextFilter(options)}
                        />
                        <Column
                          field="year"
                          header="Year"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "8%" }}
                          filterElement={(options) => renderNumericFilter(options, true)}
                        />
                        <Column
                          field="revenue"
                          header="Revenue (in million USD)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "10%" }}
                          body={(rowData) => {
                            const roundedRevenue = Math.round(rowData.revenue);
                            return roundedRevenue.toLocaleString();
                          }}
                          filterElement={(options) => renderNumericFilter(options, false)}
                        />
                        <Column
                          field="employees"
                          header="Employees"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "10%" }}
                          filterElement={(options) => renderNumericFilter(options, true)}
                        />
                        <Column
                          field="scope1Emissions"
                          header="Scope 1 (tCO2e)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "8%" }}
                          filterElement={(options) => renderNumericFilter(options, true)}
                        />
                        <Column
                          field="scope2Emissions"
                          header="Scope 2 (tCO2e)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "8%" }}
                          filterElement={(options) => renderNumericFilter(options, true)}
                        />
                        <Column
                          field="scope3Emissions"
                          header="Scope 3 (tCO2e)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "8%" }}
                          filterElement={(options) => renderNumericFilter(options, true)}
                        />
                        <Column
                          field="totalEmissions"
                          header="Total emissions (tCO2e)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "10%" }}
                          filterElement={(options) => renderNumericFilter(options, true)}
                        />
                        <Column
                          field="economicEmissionIntensity"
                          header="Economic emission intensity (tCO2e/mn USD)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "20%" }}
                          filterElement={(options) => renderNumericFilter(options, false)}
                        />
                        <Column
                          field="emissionIntensityPerEmployee"
                          header="Emission  intensity per  employee  (tCO2e/ pax)"
                          sortable
                          filter
                          filterPlaceholder="Filter"
                          style={{ width: "20%" }}
                          filterElement={(options) => renderNumericFilter(options, false)}
                        />
                      </DataTable>
                    </div>
                
              </div>
              </>
            ) : (
         
          <EmissionsCharts companyName={formData.companyName} />
        )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ESGBenchmarking;
